/**
 * Single source of truth for the workout tracker gym flag (React components and non-React code, e.g. routes).
 * The session stores this as a string; only `'true'` (case-insensitive) is treated as enabled.
 */
export function isWorkoutTrackerEnabled(value: string | null | undefined): boolean {
  return String(value ?? '').toLowerCase() === 'true';
}
